import { reportMykissClientError } from '../../helpers/errorHandling/client';
import { pathToUrl } from '../../helpers/urls';
import { ICloudfrontHeaders } from '../../interfaces/geo';

export async function getLocationData(): Promise<ICloudfrontHeaders | null> {
  try {
    const response = await fetch(pathToUrl('/api/location-info'));
    const cloudfrontLocationData = await response.json();
    if (cloudfrontLocationData) {
      return {
        ...cloudfrontLocationData,
        latitude: parseFloat(cloudfrontLocationData.latitude) || null,
        longitude: parseFloat(cloudfrontLocationData.longitude) || null,
      };
    }

    reportMykissClientError(new Error('Cloudfront location data is not found'), undefined, 'info');
  } catch (error) {
    reportMykissClientError(error);
  }

  return null;
}
